import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.webp";

function NavBar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Shared routine to flip drop menus closed and force page back to top
  const handleNavClick = () => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  // Helper function to handle active page links styling
  const linkClass = (path) => {
    const baseClass = "transition-all duration-200 font-bold tracking-wide py-1 border-b-2";
    const isActive = location.pathname === path;
    return isActive 
      ? `${baseClass} text-green-800 border-green-700` 
      : `${baseClass} text-neutral-700 border-transparent hover:text-green-800 hover:border-green-200`;
  };

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-neutral-100 shadow-md transition-all">
      <div className="flex items-center justify-between px-4 sm:px-6 md:px-12 py-4 max-w-7xl mx-auto">

        {/* Logo and Brand Branding */}
        <Link to="/" onClick={handleNavClick} className="flex items-center gap-3 group focus:outline-none">
          <img
            src={logo}
            alt="Universal Goodlife Ashram Logo"
            className="w-11 h-11 md:w-12 md:h-12 rounded-full border-2 border-green-200 group-hover:border-green-500 transition-all duration-300 shadow-sm"
          />
          <h1 className="text-lg md:text-xl xl:text-2xl font-black text-green-900 tracking-tight transition-colors group-hover:text-green-800">
            Universal Goodlife Ashram
          </h1>
        </Link>

        {/* Desktop Navigation Links */}
        <div className="hidden md:flex items-center gap-5 lg:gap-8 text-base lg:text-lg font-bold">
          <Link to="/" onClick={handleNavClick} className={linkClass("/")}>Home</Link>
          <Link to="/services" onClick={handleNavClick} className={linkClass("/services")}>Services</Link>
          <Link to="/schedule" onClick={handleNavClick} className={linkClass("/schedule")}>Schedule</Link>
          <Link to="/room" onClick={handleNavClick} className={linkClass("/room")}>Rooms</Link>
          <Link to="/about" onClick={handleNavClick} className={linkClass("/about")}>About</Link>
          <Link to="/contact" onClick={handleNavClick} className={linkClass("/contact")}>Contact</Link>
        </div>

        {/* Action Call Call-To-Action Button (Desktop Only) */}
        <div className="hidden md:block">
          <a
            href="tel:+919443043074"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-green-700 to-green-900 text-white font-black text-sm lg:text-base px-5 py-2.5 rounded-xl shadow-md hover:shadow-xl hover:shadow-green-100 transform hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200"
          >
            <span>📞</span> Contact Us
          </a>
        </div>

        {/* Mobile Interactive Hamburger Button */}
        <button
          type="button"
          aria-label="Toggle navigation menu"
          className="md:hidden text-2xl p-2 rounded-xl text-green-900 hover:bg-green-50/50 active:bg-green-50 focus:outline-none transition-all"
          onClick={() => setOpen(!open)}
        >
          {open ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Dropdown Menu Drawer */}
      <div 
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out border-green-50 ${
          open ? "max-h-[420px] border-t bg-white/95 pb-6" : "max-h-0 pointer-events-none"
        }`}
      >
        <div className="flex flex-col items-center gap-5 pt-5 text-lg font-bold text-neutral-800">
          <Link onClick={handleNavClick} to="/" className={location.pathname === "/" ? "text-green-800 font-black" : ""}>Home</Link>
          <Link onClick={handleNavClick} to="/services" className={location.pathname === "/services" ? "text-green-800 font-black" : ""}>Services</Link>
          <Link onClick={handleNavClick} to="/schedule" className={location.pathname === "/schedule" ? "text-green-800 font-black" : ""}>Schedule</Link>
          <Link onClick={handleNavClick} to="/room" className={location.pathname === "/room" ? "text-green-800 font-black" : ""}>Rooms</Link>
          <Link onClick={handleNavClick} to="/about" className={location.pathname === "/about" ? "text-green-800 font-black" : ""}>About</Link>
          <Link onClick={handleNavClick} to="/contact" className={location.pathname === "/contact" ? "text-green-800 font-black" : ""}>Contact</Link>

          <div className="w-full px-6 pt-2">
            <a
              href="tel:+919443043074"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center gap-2 bg-green-700 text-white font-black py-3 rounded-xl shadow-md active:scale-95 transition-all text-center w-full"
            >
              <span>📞</span> Contact Us
            </a>
          </div>     
        </div>
      </div>
    </nav>
  );
}

export default NavBar;